export enum PlanningEvents {
  AddPlanningRow = 'AddPlanningRow',
  DeletePlanningRow = 'DeletePlanningRow',
  UpdatePlanningCell = 'UpdatePlanningCell',
  PlanningError = 'PlanningError',
  AddPlanningRowIntent = 'AddPlanningRowIntent',
  RecurrenceClick = 'RecurrenceClick',
}
